<template>
  <div>
    <h3 class="settings__item-title" v-if="setting.title">
      {{ setting.title }}
    </h3>

    <div class="settings__item-container">
      <div class="settings__item-wrapper">
        <select
          class="settings__item-select"
          name="options"
          id="options"
          v-model="choosen"
          @change="setCollectiveAgreements"
        >
          <option
            v-for="option in setting.options"
            :key="option.id"
            :value="option.id"
          >
            {{option.name}}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsDropdown',
  props: {
    setting: Object
  },
  data () {
    return {
      choosen: this.setting.choosen == null ? 100 : this.setting.choosen // Write out 100 to match with option
    }
  },
  methods: {
    async setCollectiveAgreements() {
      this.$store.dispatch('updateCollectiveAgreements', this.choosen === 100 ? null : this.choosen) // Change 100 to null
    },
  },
}
</script>

<style lang="scss" scoped>
.settings {
  &__item {
    &-title {
      margin-bottom: 1rem;
    }

    &-container {
      display: flex;
      flex-direction: column;
      background: $light;
      width: 100%;
      padding: 2rem;
      border-radius: $borderRadius;
    }

    &-wrapper {
      position: relative;
      width: 100%;

      &:after {
        content: url(../../assets/svg/down-arrow.svg);
        right: 10px;
        top: 20px;
        padding: 0 0 2px;
        position: absolute;
        pointer-events: none;
      }
    }

    &-select {
      font-size: 1rem;
      padding: 1rem;
      width: 100%;
      border: none;
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
  }
}
</style>